import React, { useState } from 'react'
import initialFAQs from 'utils/subscription-faqs'
import { rgba } from 'polished'
import { Link } from 'gatsby'

import MetaTags from 'components/MetaTags'
import Layout from 'layouts/Layout'
import Header from 'components/subscribe/Header'
import FastestRoute from 'components/subscribe/FastestRoute'
import FreeDevice from 'components/subscribe/FreeDevice'
import Features from 'components/subscribe/Features'
import Steps from 'components/subscribe/Steps'
import Plans from 'components/subscribe/Plans'
import Faq from 'components/vype-plus/Faq'

import { black } from 'styles/colors'

const Subscribe = () => {
  const [faqs, setFaqs] = useState(initialFAQs)

  const setCategoryExpanded = (i, expanded) => {
    let newFaqs = [...faqs]
    newFaqs[i].expanded = expanded
    setFaqs(newFaqs)
  }

  const setQuestionExpanded = (i, j, expanded) => {
    let newFaqs = [...faqs]
    newFaqs[i].content[j].expanded = expanded
    setFaqs(newFaqs)
  }

  return (
    <Layout hideHeader>
      <MetaTags
        title="Subscribe easily: 💰 reduction and promotions | By Vuse"
        description="Subscribe and Save! Get up to 30% on pods and get free shipping with our Vuse subscription plan. Previously govype.ca"
      />
      <div
        css={`
          background: #252a33;
        `}
      >
        <Header />
        <Steps />
        <Plans />
        <Features />
        <FreeDevice />
        <FastestRoute />
        <div
          css={`
            background-color: ${rgba(black, 0.4)};
          `}
        >
          <Faq
            faqs={faqs}
            setCategoryExpanded={setCategoryExpanded}
            setQuestionExpanded={setQuestionExpanded}
            full
            disclaimer={
              <span>
                For full terms and conditions of the Subscription program,{' '}
                <Link to="/pages/subscription-terms-and-conditions/">click here</Link>.
              </span>
            }
          />
        </div>
      </div>
    </Layout>
  )
}

export default Subscribe
